import { render } from "./ActivitePhysique.vue?vue&type=template&id=39423ddf&scoped=true"
import script from "./ActivitePhysique.vue?vue&type=script&lang=js"
export * from "./ActivitePhysique.vue?vue&type=script&lang=js"

import "./ActivitePhysique.vue?vue&type=style&index=0&id=39423ddf&lang=scss&scoped=true"

import exportComponent from "C:\\wamp2022\\www\\emotivapp\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39423ddf"]])

export default __exports__